<div class="progress-wrapper">
  <p class="fw-semibold mb-2">Generando documentos...</p>
  <p *ngIf="activeStepCaption" class="progress-active-caption">
    {{ activeStepCaption }}
  </p>
  <mat-progress-bar
    [mode]="progressBarMode"
    [value]="progressBarValue"
    class="progress-bar mb-4"
  ></mat-progress-bar>

  <div class="steps">
    <div *ngFor="let step of steps" class="step-row">
      <div class="step-left">
        <span class="status-pill" [ngClass]="step.status">
          <mat-icon *ngIf="step.status === 'completed'">check</mat-icon>
          <mat-icon *ngIf="step.status === 'in-progress'">autorenew</mat-icon>
          <mat-icon *ngIf="step.status === 'pending'">schedule</mat-icon>
          <mat-icon *ngIf="step.status === 'error'">error</mat-icon>

          <span>
            {{
              step.status === "completed"
                ? "Completado"
                : step.status === "in-progress"
                ? "En curso"
                : step.status === "error"
                ? "Error"
                : "Pendiente"
            }}
          </span>
        </span>
        <span class="step-label">
          {{ step.label }}
        </span>
      </div>
      <div *ngIf="step.status === 'error' && step.errorMessage" class="step-error">
        {{ step.errorMessage }}
      </div>
    </div>
  </div>
</div>
